import imagem from '../../../src/assets/img/BNDES_RGB.jpg';
import './style.css'

export default function Banner() {
    return(
        <div className='containerBanner'>
            <img src={imagem}/>
        </div>
    )
}